import { Input } from "reactstrap";
import { VARIATION_BOX_DATA } from "../../../../Data/FormLayout";
import { LI, UL } from "../../../../AbstractElements";

const VariationBox = () => {
  return (
    <div className="variation-box mb-3">
      {VARIATION_BOX_DATA.map((data, index) => (
        <div className="selection-box" key={index}>
          <Input type="checkbox" />
          <div className="custom--mega-checkbox">
            <UL className="d-flex flex-column simple-list">
              <LI>{data.tittle}</LI>
              <LI className="txt-primary">{data.details}</LI>
            </UL>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VariationBox;
